import React, { useState } from "react";
import "../close_modal/Close_modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import {
  deleteTrades,
} from "../../../../utils/apis/buy_and_sell/buy_and_sell";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Delete_modal = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitClose = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const res = await deleteTrades(props.closeTradeId);

      if (res?.success) {
        toast.success("Trade canceled successfully!", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });

        props?.getGraphData();
        props?.getuserData(props?.userdata?.id);
        props.onHide(true);
      } else {
        const msg = res?.message || "Failed to cancel trade";
        toast.error(msg, { position: "bottom-right" });
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("An error occurred. Please try again.", { position: "bottom-right" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer position="bottom-right" theme="dark" />

      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="close_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Cancel Trade
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text-center py-4">
            <p className="msgg fw-bold">Do you want to cancel this trade?</p>
          </div>
        </Modal.Body>

        <Modal.Footer className="justify-content-center border-0 pb-4">
          <Button
            variant="outline-secondary"
            className="me-3 px-4"
            onClick={() => props.onHide()}
            disabled={isSubmitting}
          >
            No
          </Button>

          <Button
            className="confirmbtn px-5"
            onClick={submitClose}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Cancelling..." : "Yes, Cancel"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Delete_modal;